import axios from "axios";
import GenerarExternalReference from "./GenerarExternalReference";
import MP_payerData from "../types/MP_payerData";
import MP_paymentData from "../types/MP_paymentData";

//import guardarTransaccion from "./guardarTransaccion";

export default async function SuscripcionMP(pagador: MP_payerData, pago: MP_paymentData) {

    const url = "https://endpoints.mapsys.com.ar/pagos/create_subscription";
    
    // Creo un identificador único para la transacción (externalReference)
    const externalReference = GenerarExternalReference(pagador.titular);
    
    const data = {
        customer: {
            email: pagador.payerEmail,
            first_name: pagador.payerFirstName,
            last_name: pagador.payerLastName,
            identification: {
                type: pagador.identification.type,
                number: pagador.identification.number
            }
        },
        subscription: {
            auto_recurring: {
                frequency: 1,
                frequency_type: "months",
                transaction_amount: pago.transactionAmount, //Eñ importe de la suscripción
                currency_id: "ARS",
                billing_day: 1
            },
            back_url: "https://www.vidaplus.com.ar/suscripcion_exitosa",
            notification_url: "https://endpoints.mapsys.com.ar/pagos/webhook_mercadopago",
            external_reference: externalReference,
            payer_email: pagador.payerEmail,
            //card_token_id: pago.cardToken,
            reason: "VidaPlus Suscrip. Mensual",
            status: "pending"
        }
    };
    
    try {
        const response = await axios.post(url, data);
        return response.data;
    } catch (error) {
        return error;
    }
};
